import { Static, Type } from '@sinclair/typebox';
import { makeNullable } from '../../utils/typeboxHelpers';

export const userTableSchema = Type.Object({
    id: Type.String({ format: 'uuid' }),
    firstName: makeNullable(Type.String({ maxLength: 255 })),
    lastName: Type.String({ maxLength: 255 }),
    emailAddress: Type.String({ maxLength: 255 }),
    mobileNumber: makeNullable(Type.String({ maxLength: 255 })),
    officeNumber: makeNullable(Type.String({ maxLength: 255 })),
    password: Type.String({ maxLength: 255 }),
    salt: Type.String({ maxLength: 255 }),
    lastLoginOn: makeNullable(Type.String()),
    status: makeNullable(Type.String()),
    language: Type.String({ maxLength: 255 }),
    created_at: makeNullable(Type.String()),
    updated_at: makeNullable(Type.String()),
    loginAttempts: Type.Integer(),
    isReadOnly: makeNullable(Type.Boolean()),
    isAccountManager: makeNullable(Type.Boolean()),
    isConfigurationManager: makeNullable(Type.Boolean()),
    passwordChangeDate: makeNullable(Type.String()),
    isDeleted: Type.Boolean(),
    newPasswordToken: makeNullable(Type.String({ maxLength: 255 })),
    newPasswordTokenDate: makeNullable(Type.String()),
    newPasswordTokenUsed: Type.Boolean(),
    hasOtpEnabled: Type.Boolean(),
    otpSecret: makeNullable(Type.String({ maxLength: 255 })),
    isDroneOperator: makeNullable(Type.Boolean()),
    lastLoginAttemptedOn: makeNullable(Type.String()),
    enableOtpMessageFirstShownOn: makeNullable(Type.String()),
});

export const userCompanyTableSchema = Type.Object({
    userId: Type.String({ format: 'uuid' }),
    companyId: Type.String({ format: 'uuid' }),
    created_at: Type.String(),
});

export type User = Static<typeof userTableSchema>;
export type UserCompany = Static<typeof userCompanyTableSchema>;
